import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
    private authService: AuthenticationService
  ) { }


  error(message, methodName:String){
    return this.logmessage(message, methodName, 'error');
  }
  info(message, methodName:String){
    return this.logmessage(message, methodName, 'info');
  }

  private logmessage(message, methodName:String, severity:String){
    let url = this.environmentService.getEnvironmentUrl("service/log/");


    let logobject = {
      applicationName: this.environmentService.sitename,
      applicationContext: this.environmentService.getProgramKey(),
      moduleName: this.environmentService.sitename,
      methodName: methodName,
      userAgentName: window.navigator.userAgent,
      userSessionToken: this.authService.authtoken,
      severityLevel: severity,
      logMessage: message,
    }

    return this.http.put(url, logobject);

  }

  errorcc(message, methodName:String){
    return this.logmessage(message, methodName, 'error');
  }
}
